module.exports = __webpack_public_path__ + "img/a-4.f4dcc364.png";